import React from 'react';
import ResetPasswordForm from 'components/reset-password';
import { createStyles } from '../../globalStyles';

const ResetPasswordPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={classes.formWrapper}>
      <h1 className={classes.title}>Reset Your Password</h1>
      <ResetPasswordForm />
    </div>
  );
};

export default ResetPasswordPage;
